import { Fade } from "@mui/material";
import { useAppSelector } from "../../../store/hooks";
import { selectActiveRobotVersion } from "../../../store/ses/sesRobotSlice";
import { selectClusterServer } from "../../../store/serverSlice";
import useAccessRight from "../../../hooks/useAccessRight";
import useTranslate from "../../../hooks/useTranslate";
import { SES } from "../../../constants/accessRights";
import { ROBOT_SERVICE_DATA_LIST } from "../../../constants/robotConfigLists";
import { ServiceDataType } from "../../../types/ses/sesRobotTypes";
import ServiceData from "../ServiceData/ServiceData";
import BlockWithInfo from "../../../ui/BlockWithInfo/BlockWithInfo";
import FormAddingServiceData from "../../Forms/FormAddingServiceData/FormAddingServiceData";
import { IServiceDataTabProps } from "./ServiceDataTab.props";
import styles from "./ServiceDataTab.module.scss";
import { CustomMenuItem, CustomTextField } from "@/ui";

const ServiceDataTab = ({ robotData, changeFlgHandler, selectServiceData, setSelectServiceData }: IServiceDataTabProps): JSX.Element => {
	const activeRobotVersion = useAppSelector(selectActiveRobotVersion); // store - версия активного робота
	const { smc: clusterServerSmc, see: clusterServerSee } = useAppSelector(selectClusterServer); // store - список моделей на сервере cluster

	const isAccess = useAccessRight(); // hook для проверки прав доступа
	const translate = useTranslate(); // hook для перевода текста

	return (
		<Fade in={true} timeout={500}>
			<div className={styles.container}>
				<div className={styles.block}>
					{/* сервисные данные */}
					<CustomTextField
						select
						fullWidth
						label={translate("select_serviceData")}
						value={selectServiceData}
						onChange={(e) => setSelectServiceData(e.target.value as ServiceDataType)}
					>
						{ROBOT_SERVICE_DATA_LIST.map(({ serviceData, translation }) => (
							<CustomMenuItem key={serviceData} value={serviceData}>
								{translate(translation)}
							</CustomMenuItem>
						))}
					</CustomTextField>
				</div>

				<div className={styles.serviceData}>
					{robotData.servicedata[selectServiceData] ? (
						<ServiceData
							data={robotData.servicedata[selectServiceData]}
							serviceDataName={selectServiceData}
							modelsList={robotData.servicedata[selectServiceData].type === "smc" ? clusterServerSmc.modelList : clusterServerSee.modelList}
							changeFlgHandler={changeFlgHandler}
						/>
					) : isAccess(SES.ROBOT_EDIT) && activeRobotVersion === "draft" ? (
						<FormAddingServiceData serviceDataName={selectServiceData} changeFlgHandler={changeFlgHandler} />
					) : (
						<BlockWithInfo title="title_empty" />
					)}
				</div>
			</div>
		</Fade>
	);
};

export default ServiceDataTab;
